import type { AlgoliaFacets } from '@jane/search/types';
/* eslint-disable-next-line no-restricted-imports */
import type { Store } from '@jane/shared/models';
import type { MenuCategoryPath } from '@jane/shared/types';

export const getMenuTabs = ({
  facets,
  isMarketplace,
  menuTabs,
  showGoldTab,
  specialsPage,
}: {
  facets?: AlgoliaFacets;
  isMarketplace?: boolean;
  menuTabs: Store['menu_tabs'];
  showGoldTab?: boolean;
  specialsPage?: boolean;
}): MenuCategoryPath[] => {
  if (!facets || typeof specialsPage === 'undefined') {
    return [];
  }

  const shouldAddJaneGoldForSpecials =
    showGoldTab && isMarketplace && !menuTabs.includes('brand_specials');
  const shouldAddJaneGoldForFeatured =
    showGoldTab &&
    isMarketplace &&
    !menuTabs.includes('brand_specials') &&
    !(menuTabs.includes('specials') && specialsPage);

  const reducedMenuTabs: MenuCategoryPath[] = [];

  for (const tab of menuTabs) {
    if (tab === 'specials' && specialsPage) {
      reducedMenuTabs.push(tab);
      if (shouldAddJaneGoldForSpecials) {
        reducedMenuTabs.push('jane-gold');
      }
    } else if (tab === 'featured') {
      reducedMenuTabs.push(tab);
      if (shouldAddJaneGoldForFeatured) {
        reducedMenuTabs.push('jane-gold');
      }
    } else if (tab === 'brand_specials' && showGoldTab) {
      reducedMenuTabs.push('jane-gold');
    } else if (tab === 'all-products') {
      reducedMenuTabs.push('all');
    } else if ((facets?.root_types || {})[tab]) {
      reducedMenuTabs.push(tab as MenuCategoryPath);
    }
  }

  if (showGoldTab && isMarketplace && !reducedMenuTabs.includes('jane-gold')) {
    reducedMenuTabs.unshift('jane-gold');
  }

  return reducedMenuTabs;
};
